import { Responsive } from '@cian/ui-kit';
import { BigTitle } from '../../../BigTitle';
import { Block } from '../../../Block';
import { Description } from '../../../Description';
import { Wrapper } from '../../../Wrapper';
import * as styles from './styles.css';
import { SubTitle } from 'shared/components/SubTitle';
import { clsx } from 'clsx';
import { DESCRIPTION, LIST } from './constants';

export const NetworkEffect: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper withoutPaddingBottom>
        <Block>
          <BigTitle text="Про сетевой эффект" />
          <Description text={DESCRIPTION} />
        </Block>
        <Responsive desktop>
          <div className={styles['image']} />
        </Responsive>
        <Responsive tablet phone>
          <div className={styles['list']}>
            {LIST.map(({ image, title, description }, key) => (
              <div className={styles['list-item']} key={key}>
                <div className={clsx(styles['item-image'], styles[image])} />
                <SubTitle text={title} />
                {description.map((descrItem, key) => (
                  <Description key={key} text={[{ value: descrItem }]} />
                ))}
              </div>
            ))}
          </div>
        </Responsive>
      </Wrapper>
    </div>
  );
};
